import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '../../../store/state/app.state';

// TODO: Add Angular decorator. Temporal workaround
@Injectable({
    providedIn: 'root',
})
export abstract class BusinessCardComponent implements OnDestroy {
    labels: {[key: string]: string};
    header: string;
    protected destroy$: Subject<void> = new Subject();
    abstract id: string;

    protected constructor(
        protected store: Store<AppState>,
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
